import { motion } from "framer-motion";
import { Reveal } from "@/lib/motion";
import { BRAND, IMAGES } from "@/data/urban";

export const About = () => (
  <section id="about" className="py-20 md:py-28 bg-white">
    <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-10">
      <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-7">
          <Reveal><div className="overline text-ink-soft">About Urban Renovations</div></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-3 font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold text-ink leading-tight">
              Budget-friendly interiors, done properly.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-5 text-ink-soft leading-relaxed max-w-xl">
              Urban Renovations is the customer-facing brand of <span className="text-ink font-semibold">{BRAND.company}</span>, a home interior and renovation business working since <span className="text-ink font-semibold">{BRAND.since}</span>. We focus on modular kitchens, wardrobes, doors, complete home interiors and renovation — designed around your space, lifestyle and budget.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3 text-sm">
              {[
                "Modular kitchens starting ₹1,200/sq.ft.",
                "Wardrobes & designer doors",
                "Complete home interior solutions",
                "Painting, waterproofing & civil work",
                "Transparent, itemised quotations",
                "Free site visit across Gurgaon & Delhi NCR",
              ].map((f) => (
                <li key={f} className="flex items-center gap-2 text-ink"><span className="h-1.5 w-1.5 rounded-full bg-black" />{f}</li>
              ))}
            </ul>
          </Reveal>
        </div>

        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <motion.div initial={{ clipPath: "inset(0 0 100% 0)" }} whileInView={{ clipPath: "inset(0 0 0% 0)" }} viewport={{ once: true }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }} className="rounded-2xl overflow-hidden">
              <img src={IMAGES.living} alt="Urban Renovations interior design in Gurgaon" className="w-full h-[520px] object-cover" />
            </motion.div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
